// Mute/unmute toggle for the homepage hero video. Browsers flatly
// refuse unmuted autoplay, so the Vimeo embed has to start muted --
// this is how people can still choose to hear it. Vimeo's Player.js
// (window.Vimeo, loaded in default.hbs on the home page only, before
// this script -- see the comment there) drives the existing
// background=1 iframe directly via postMessage; no visible Vimeo UI
// needed for it.

export default function heroVideo() {
    const iframe = document.querySelector(".video-frame iframe");
    const button = document.getElementById("hero-sound-toggle");
    if (!iframe || !button || typeof Vimeo === "undefined") {
        return;
    }

    const player = new Vimeo.Player(iframe);
    const iconOff = button.querySelector('[data-icon="off"]');
    const iconOn = button.querySelector('[data-icon="on"]');

    function render(muted) {
        iconOff.hidden = !muted;
        iconOn.hidden = muted;
        button.setAttribute("aria-label", muted ? "Unmute video" : "Mute video");
    }

    button.addEventListener("click", () => {
        player.getMuted().then((muted) => {
            const next = !muted;
            player.setMuted(next).then(() => render(next));
        });
    });
}
